import React, { useEffect, useState } from 'react'
import { AiFillCloseCircle } from 'react-icons/ai'

const MwModal = ({
    title,
    children,
    onShow,
    setOnShow,
    saveHandler=()=>{},
    cancelHandle=()=>{},
    panelClassName='',
    bodyClassName=''
}) => {
    const [isHidden,setIsHidden] = useState(true);

    const onHide = () => {
        setIsHidden(true);
        setOnShow(false);
        cancelHandle();
        
    }
    
    useEffect(()=>{
        setIsHidden(!onShow);
    },[onShow]);
    
    const ChildrenComponent = (props) => {
        return React.cloneElement(children, props);
    }
    return (
        <div className={`items-center justify-center bg-gray-700/75 fixed inset-0 z-[9999] p-3 md:p-6 ${ !isHidden ? 'flex' : 'hidden'  } `} >
            <div className={`flex flex-col w-full max-w-4xl bg-white rounded-xl overflow-hidden relative max-h-[calc(100vh-32px)] shadow-2xl ${panelClassName}`}>
                <div
                    className='flex items-center justify-between bg-white border-b border-slate-200 px-4 py-3 text-sm font-semibold sticky top-0 z-10 shrink-0'
                    >
                    <div>{title}</div>
                    <AiFillCloseCircle size={24} onClick={onHide} className='cursor-pointer text-slate-500 hover:text-sky-800' />
                </div>
                <div className={`bg-slate-50 overflow-y-auto min-h-0 ${bodyClassName}`} >
                    <ChildrenComponent onHide={onHide} saveHandler={saveHandler} cancelHandle={cancelHandle} /> 
                </div>
            </div>

        </div>
    )
}

export default MwModal
